const data = [
  {
    icon: 'iconsminds-bar-chart-4 d-block ',
    label: 'Insights',
    to: '/app/dashboards/analytics',
    domains: [
      'AccommodationProviders',
      'RetirementHomes',
      'Salons',
      'HolidaysPark',
      'VoucherEngine',
      'VoucherEngine',
      'HolidayHomes',
      'VirtualVetNurse',
      'AllGroups',
      'Tourism',
      'Doctors',
      'Northable',
      'Golf',
    ],
  },
  {
    id: 'vouchers',
    icon: 'iconsminds-qr-code ',
    label: 'Vouchers',
    to: '/app/pages/vouchers',
    domains: ['VoucherEngine', 'AccommodationProviders', 'HolidaysPark'],
    subs: []
  },
  {
    id: 'Orders',
    icon: 'iconsminds-shopping-cart',
    label: 'Orders',
    to: '/app/pages/orders',
    domains: ['VoucherEngine', 'AccommodationProviders', 'HolidaysPark'],
  },
  // {
  //   id: 'Statement',
  //   icon: 'iconsminds-receipt-4',
  //   label: 'Statement',
  //   to: '/app/pages/statement',
  //   domains: ['VoucherEngine', 'AccommodationProviders', 'HolidaysPark'],
  // },
  // {
  //   id: 'Invitations',
  //   icon: 'iconsminds-email',
  //   label: 'Invitations',
  //   to: '/app/pages/invitations',
  //   domains: ['VoucherEngine', 'AccommodationProviders', 'HolidaysPark'],
  // },
  {
    id: 'integration',
    icon: 'iconsminds-equalizer',
    label: 'menu.integration',
    to: '/app/pages/integration',
    domains: [
      'AccommodationProviders',
      'RetirementHomes',
      'Salons',
      'HolidaysPark',
      'QuarantineBot',
      'HolidayHomes',
      'VoucherEngine',
      'VirtualVetNurse',
      'AllGroups',
      'Tourism',
      'Doctors',
      'Northable',
      'Golf',
    ],
  },
  // {
  //   id:'gallery',
  //   icon: 'iconsminds-picasa',
  //   label: 'property-info.gallery',
  //   to: '/app/pages/propinfo/gallery',
  //   domains: [
  //     'AccommodationProviders',
  //     'RetirementHomes',
  //     'Salons',
  //     'HolidaysPark',
  //     'QuarantineBot',
  //     'HolidayHomes',
  //     'Doctors',
  //     'Golf',
  //     'VoucherEngine',
  //   ],
  // }, 
  {
      id: 'admin',
      type: 'sa',
      icon: 'iconsminds-security-settings',
      label: 'menu.userroles',
      to: '/app/pages/admin',
      domains: [
        'AccommodationProviders',
        'RetirementHomes',
        'Salons',
        'HolidaysPark',
        'QuarantineBot',
        'VoucherEngine',
        'HolidayHomes',
        'VirtualVetNurse',
        'AllGroups',
        'Tourism',
        'Doctors',
        'Northable',
        'Golf',
      ],
   },
  // {
  //   id: 'ari',
  //   icon: 'iconsminds-money-bag',
  //   label: 'menu.ari',
  //   to: '/app/pages/ari',
  //   domains: ['AccommodationProviders']
  // },

  // {
  //   id: 'rate-promos',
  //   icon: 'iconsminds-tag-3',
  //   label: 'menu.rate-promos',
  //   to: '/app/pages/rate-promos',
  //   domains: ['AccommodationProviders'],
  //   subs: [
  //     {
  //       icon: 'iconsminds-basket-coins',
  //       label: 'rate-promo.rate-plans',
  //       to: '/app/pages/rate-promos/rate-plans',
  //       domains: ['AccommodationProviders']
  //     },
  //     {
  //       icon: 'iconsminds-plug-in',
  //       label: 'rate-promo.rate-plan-addons',
  //       to: '/app/pages/rate-promos/rate-plan-addons',
  //       domains: ['AccommodationProviders']
  //     },
  //     {
  //       icon: 'iconsminds-tag',
  //       label: 'rate-promo.rate-plan-promos',
  //       to: '/app/pages/rate-promos/rate-plan-promos',
  //       domains: ['AccommodationProviders']
  //     },
  //   ],
  // },

  // {
  //   id: 'finance',
  //   icon: 'iconsminds-formula ',
  //   label: 'menu.finance',
  //   to: '/app/pages/finance',
  //   domains: ['AccommodationProviders', 'RetirementHomes']
  // },
  // {
  //   id: 'bookings',
  //   icon: 'iconsminds-pantone ',
  //   label: 'menu.bookings',
  //   to: '/app/pages/bookings',
  //   domains: ['AccommodationProviders']
  // }
  {
    id: 'sa',
    icon: 'iconsminds-king-2',
    label: 'Super Admin',
    to: '/app/pages/sa',
    type: 'sa',
    domains: [
      'AccommodationProviders',
      'RetirementHomes',
      'Salons',
      'HolidaysPark',
      'QuarantineBot',
      'VoucherEngine',
      'HolidayHomes',
      'VirtualVetNurse',
      'AllGroups',
      'Tourism',
      'Doctors',
      'Northable',
      'Golf',
    ],
    subs: [
      {
        icon: 'iconsminds-affiliate',
        label: 'Groups',
        to: '/app/pages/sa/groups',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'VoucherEngine',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
        ],
      },
      {
        icon: 'iconsminds-home-1',
        label: 'Properties',
        to: '/app/pages/sa/properties',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'VoucherEngine',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
        ],
      },
      {
        icon: 'iconsminds-shopping-cart',
        label: 'All Orders',
        to: '/app/pages/sa/orders',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'VoucherEngine',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
        ],
      },
      {
        icon: 'iconsminds-receipt-4',
        label: 'To-Do List',
        to: '/app/pages/sa/todo',
        domains: [
          'AccommodationProviders',
          'RetirementHomes',
          'Salons',
          'HolidaysPark',
          'QuarantineBot',
          'VoucherEngine',
          'HolidayHomes',
          'VirtualVetNurse',
          'AllGroups',
          'Tourism',
          'Doctors',
          'Northable',
          'Golf',
        ],
      }
    ]
  }
];
export default data;
